<template>
  <el-autocomplete
    v-model="state"
    :fetch-suggestions="querySearch"
    :placeholder="placeholder"
    @select="handleSelect"
    @clear="clearSearch"
    :popper-append-to-body="false"
    clearable
    label="name"
    class="el-list-input"
    popper-class="my-autocomplete"
    prefix-icon="el-icon-search"
  >
    <template v-slot="{ item }">
      <div v-if="item.isGroup" class="group">
        <span class="title">
          {{ item?.label }}
        </span>
      </div>
      <div v-else class="options">
        <span class="name">
          {{ item?.name }}
          <span v-if="item?.projectcount > 0" class="project-num">
            ({{ item?.projectcount }}个工地)
          </span>
        </span>
        <span class="address">{{ item.address }}</span>
      </div>
    </template>
  </el-autocomplete>
</template>
<script>
import { depcratedGetSearchTipsTencent } from '~/api/amap.api'
export default {
  props: {
    communityList: {
      default: () => [],
      type: Array
    }
  },
  data() {
    return {
      filterOptions: [],
      isAndroid: false,
      isIOS: false,
      placeholder: '搜索小区',
      state: '',
      currentPosition: null
    }
  },
  methods: {
    setValue(value) {
      this.state = value
    },
    setCurrentLocation(currentPosition) {
      if (!this.currentPosition) {
        this.currentPosition = currentPosition
      }
    },
    async querySearch(queryString, cb) {
      const resOptions = []
      if (!queryString) {
        cb(resOptions)
        return
      }
      const community = this.communityList
      const options = community.filter(this.createFilter(queryString))
      let mapOptions = []
      const mapRes = await depcratedGetSearchTipsTencent(
        this.currentPosition,
        queryString
      )

      mapOptions = mapRes.data?.map((el) => {
        return {
          address: el.city + el.district + el.address,
          name: el.name,
          district: el.district,
          level: 3,
          isRecommend: 'Y',
          position: [String(el.location.lng), String(el.location.lat)]
        }
      })
      if (options.length > 0) {
        resOptions.push(
          {
            label: '在建小区',
            isGroup: true
          },
          ...options
        )
      }
      if (mapOptions.length > 0) {
        resOptions.push(
          {
            label: '地图推荐',
            isGroup: true
          },
          ...mapOptions
        )
      }
      cb(resOptions)
    },
    clearSearch() {
      this.queryString = ''
      this.$emit('clear-target')
    },
    selectChange(value) {
      this.queryString = value
    },
    judgeGlobalSearch(ctx, str) {
      const input = strCodeAt(str)
      const reg = new RegExp(input)
      if (reg.test(ctx)) {
        return true
      } else {
        return false
      }
      function strCodeAt(str) {
        const arr = str.split('')
        const result = arr.map((item) => {
          const judgeZh = /[\u4E00-\u9FA5|\u3002|\uFF1F|\uFF01|\uFF0C|\u3001|\uFF1B|\uFF1A|\u201C|\u201D|\u2018|\u2019|\uFF08|\uFF09|\u300A|\u300B|\u3008|\u3009|\u3010|\u3011|\u300E|\u300F|\u300C|\u300D|\uFE43|\uFE44|\u3014|\u3015|\u2026|\u2014|\uFF5E|\uFE4F|\uFFE5]/.test(
            item
          )
          const judgeEn = /[a-zA-Z]/.test(item)
          const judgeNum = /[0-9]/.test(item)
          if (judgeZh) {
            return '\\u' + item.charCodeAt().toString(16)
          } else if (judgeEn || judgeNum) {
            return item
          } else {
            return '\\' + item
          }
        })
        return result.join('')
      }
    },
    createFilter(str) {
      const vm = this
      if (str === null || str === undefined || str === '') {
        return () => {
          return false
        }
      }
      return (restaurant) => {
        return (
          vm.judgeGlobalSearch(restaurant.name, str) ||
          vm.judgeGlobalSearch(restaurant.address, str)
        )
      }
    },
    handleSelect(item) {
      if (item.isGroup) {
        this.state = ''
        return
      }
      this.state = item.name
      this.$emit('move-to-target', item)
    }
  }
}
</script>
<style lang="scss" scoped>
:deep(.el-input input) {
  background: inherit;
}

:deep(.el-autocomplete-suggestion__wrap) {
  padding: 10px 0;
}

:deep(.el-autocomplete-suggestion) {
  width: 360px !important;
}

:depp(.el-autocomplete-suggestion__wrap) {
  padding: 0 !important;
}

.group {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.title {
  font-weight: 400;
  font-size: 14px;
  color: #909399;
  line-height: 36px;
  border-bottom: 1px solid #ebeef5;
}

.options {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  height: 64px;
}

.name {
  height: 20px;
  font-weight: 500;
  font-size: 14px;
  color: #606266;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis; //文本溢出显示省略号
  white-space: nowrap; //文本不会换行
}

.project-num {
  font-weight: 400;
  font-size: 14px;
  color: #909399;
  line-height: 22px;
}

.address {
  font-size: 13px;
  color: #606266;
  line-height: 19px;
  overflow: hidden;
  text-overflow: ellipsis; //文本溢出显示省略号
  white-space: nowrap; //文本不会换行
}
</style>
